import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'GROUP_HEADER';

export const {action: groupSelected} = createAction(`${domain}/GROUP_SELECTED`, (groupId: string) => ({groupId}));
